import GraphicsIcon from './component'

export default GraphicsIcon
